import type { SearchResultKeys } from '@sparkai/shared-types'

import { createContext, ReactNode, useContext } from 'react'

export interface SearchConfigState {
  placeholder: string
  blacklist?: SearchResultKeys[]
  legend: string
  hideActiveOnly?: boolean
  routes?: {
    overrideDefault?: string
  }
}

const SearchContext = createContext<SearchConfigState | undefined>(undefined)
SearchContext.displayName = 'SearchContext'

interface SearchContextProviderProps extends SearchConfigState {
  children: ReactNode
}

export const SearchContextProvider: React.FC<SearchContextProviderProps> = ({
  children,
  placeholder,
  legend,
  blacklist,
  routes,
  hideActiveOnly,
}) => {
  return (
    <SearchContext.Provider value={{ placeholder, legend, blacklist, routes, hideActiveOnly }}>
      {children}
    </SearchContext.Provider>
  )
}

export function useSearchConfig() {
  const context = useContext(SearchContext)

  if (!context) throw new Error('useSearchConfig must be used within a SearchContextProvider')

  return context
}
